// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#dynamicElementClick {
  opacity: 0;
  height: 0;
  padding: 0;
  margin: 0;
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/system-common/xml-html-ui/xml-html-ui.component.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;AACF","sourcesContent":["#dynamicElementClick {\r\n  opacity: 0;\r\n  height: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  width: 100%;\r\n  display: block;\r\n  position: absolute;\r\n  top: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
